import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';
import uniq from 'lodash/uniq';

import ShowApartmentNumber from '@spotahome/marketplace-common/src/components/ShowApartmentNumber';
import CheckBox from '@spotahome/marketplace-common/src/LEGACY/javascripts/ui/form/form-checkbox';
import GroupToggle from '@spotahome/marketplace-common/src/LEGACY/javascripts/ui/form/form-group-toggle';

import NUMBER_ROOMS_TOGGLE from './constants/rooms-config';

const PropertyTypeFilterDropdown = ({ filters, onFiltersUpdate }) => {
  const handleToggleCheckbox = (name, value, isChecked) => {
    let options = filters[name];
    if (isChecked) {
      options = [...options, value];
    } else {
      options = options.filter(option => option !== value);
    }

    onFiltersUpdate({
      [name]: uniq(options)
    });
  };

  const handleApartmentsFilterTypeCheckbox = value => isChecked =>
    handleToggleCheckbox('type[]', value, isChecked);

  const isValueChecked = (arr = [], value) => arr.includes(value);

  const isPropertyTypeChecked = value =>
    isValueChecked(filters['type[]'], value);

  const handleToggleFilterTypeCheckbox = value => isChecked =>
    handleToggleCheckbox('type[]', value, isChecked);

  const handleTopologyClick = (name, value, isChecked) =>
    handleToggleCheckbox('topology[]', value, isChecked);

  const getSelectedTopologies = () => filters['topology[]'].join(',');

  return (
    <div>
      <CheckBox
        id="apartment-id"
        label={trans('search.filter.apartments')}
        onChange={handleApartmentsFilterTypeCheckbox('apartments')}
        checked={isPropertyTypeChecked('apartments')}
        tracking="ga-search-form-apartments"
        dataTest="apartment-id"
      />
      {isPropertyTypeChecked('apartments') && (
        <>
          <ShowApartmentNumber number={filters['topology[]']} />
          <GroupToggle
            onChange={handleTopologyClick}
            selectedValues={getSelectedTopologies()}
            options={NUMBER_ROOMS_TOGGLE}
            key="specific-key-room"
          />
        </>
      )}
      <CheckBox
        id="studios-id"
        label={trans('search.filter.studios')}
        onChange={handleToggleFilterTypeCheckbox('studios')}
        checked={isPropertyTypeChecked('studios')}
        tracking="ga-search-form-studios"
        dataTest="studios-id"
      />
      <CheckBox
        id="rooms-id"
        label={trans('search.filter.rooms')}
        onChange={handleToggleFilterTypeCheckbox('rooms')}
        checked={isPropertyTypeChecked('rooms')}
        tracking="ga-search-form-rooms"
        dataTest="rooms-id"
      />
      <CheckBox
        id="residences-id"
        label={trans('search.filter.residences')}
        onChange={handleToggleFilterTypeCheckbox('residences')}
        checked={isPropertyTypeChecked('residences')}
        tracking="ga-search-form-residences"
        dataTest="residences-id"
      />
    </div>
  );
};

PropertyTypeFilterDropdown.propTypes = {
  filters: PropTypes.shape({
    'topology[]': PropTypes.arrayOf(PropTypes.string),
    'type[]': PropTypes.arrayOf(PropTypes.string)
  }),
  onFiltersUpdate: PropTypes.func.isRequired
};

PropertyTypeFilterDropdown.defaultProps = {
  filters: {
    'topology[]': [],
    'type[]': []
  }
};

export default PropertyTypeFilterDropdown;
